module.exports = __webpack_public_path__ + "img/vonexLogo.82d10efc.png";